exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".product .quantity-select-action input[type='number'][data-v-0e89fc8e] {\n  padding: 0;\n}\n.product + .product[data-v-0e89fc8e] {\n  border-top-width: 1px;\n  border-color: #d0d0d0;\n}\n", ""]);

// exports
